import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import {
  FavoriteChecked,
  FavoriteDefault,
} from '@/theme/overrides/CustomIcons';

type P = {
  isBookMark: boolean;
  handleClick(): void;
  disabled?: boolean;
};

const BookMarkButton = ({ isBookMark, handleClick, disabled = false }: P) => {
  const { t } = useTranslation();
  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    handleClick();
  };
  return (
    <StyledBookMarkLayout
      onClick={(e) => onClick(e)}
      disabled={disabled}
      aria-label={isBookMark ? t('즐겨찾기 해제') : t('즐겨찾기 추가')}
    >
      {isBookMark ? (
        <FavoriteChecked width={16} height={16} />
      ) : (
        <FavoriteDefault />
      )}
    </StyledBookMarkLayout>
  );
};

export default BookMarkButton;

const StyledBookMarkLayout = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  //padding: 4px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  min-width: 30px;
  height: 30px;

  > svg {
    vertical-align: middle;
  }
  &:hover {
    background-color: var(--dk-bg-strong, #e7e9ec);
  }
  transition: background-color 0.2s ease-in-out;
`;
